module.exports = __webpack_public_path__ + "img/hand-holding-heart.ee9481ea.svg";